import SessionStorage from '@ustra/core/src/utils/storage/session-storage'
import { StringConverter } from '@ustra/core/src/utils/converter/string-converter'
import { $ustra } from '../nuxt-utils'

const contextPathSessionStorage = new SessionStorage({
  keyConverter: {
    convert: key => {
      return $ustra().contextPath + key
    },
    deConvert: key => {
      return key
    },
  },
})

export { contextPathSessionStorage }
